import React from "react";
import PolicyPage from "./PolicyPage";
import { policyDocuments } from "../Datas/policyData";

function Returns() {
  return <PolicyPage document={policyDocuments.returns} />;
}

export default Returns;
